<template>
    <span v-html="bookseller.activeStatusLabel" :class="booksellerActiveStatusClasses"/>
</template>

<script>
export default {
    name: "BooksellerActiveStatus",
    props: {
        bookseller: {
            required: true,
            type: Object,
        },
    },
    computed: {
        booksellerActiveStatusClasses() {
            const statusColors = {
                active: "success",
                notActivatedYet: "warning",
                blocked: "danger",
            };
            return `badge badge-${statusColors[this.bookseller.activeStatus]}`;
        },
    },
};
</script>

<style scoped>

</style>